<template>
  <div v-if="stories?.length" class="container">
    <div class="row flex-wrap gutter-sm">
      <CustomCard
        v-for="(card, index) in blok"
        :key="card.id"
        :blok="stories[index] || {}"
        :card-type="cardType"
        :class="
          cardType === 'featured'
            ? 'sm-12'
            : cardType === 'vertical'
              ? 'sm-6 lg-4'
              : 'sm-6'
        "
        :custom-story="card"
        class="xs-12"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { CustomCardStoryblok } from '~/types/storyblok'

const props = withDefaults(
  defineProps<{
    blok?: CustomCardStoryblok[]
    cardType?: string
  }>(),
  {
    cardType: 'featured',
    blok: () => [],
  },
)
const stories = ref([])
const storyIds = computed(() => props.blok.map((s) => s.reference).join(','))

async function fetch() {
  const { data } = await useStoryblokHelpers().fetchAsyncData<unknown>(
    'stories',
    {
      by_uuids_ordered: storyIds.value,
    },
  )
  stories.value = data.value.data.stories || []
}
watch(() => storyIds, fetch)
await fetch()
</script>
